export type OwnerListingStatus = 'published' | 'featured' | 'draft' | 'expired' | 'paused';

export interface OwnerListing {
  id: string;
  title: string;
  type: string;
  mode: 'sale' | 'rent';
  price: number;
  priceUnit: string;
  city: string;
  district: string;
  area: number;
  bedrooms: number | null;
  status: OwnerListingStatus;
  views: number;
  unlocks: number;
  listedAt: string;
  expiresAt: string;
  image: string;
  imageAlt: string;
  furnished?: boolean;
}

export const OWNER_LISTINGS: OwnerListing[] = [
{
  id: 'own-001',
  title: 'شقة فاخرة في دبي مارينا مع إطلالة على البحر',
  type: 'شقة',
  mode: 'rent',
  price: 9500,
  priceUnit: 'AED/شهر',
  city: 'دبي',
  district: 'دبي مارينا',
  area: 145,
  bedrooms: 3,
  status: 'featured',
  views: 312,
  unlocks: 18,
  listedAt: '2026-04-02',
  expiresAt: '2026-07-02',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_110beb963-1774897481161.png",
  imageAlt: 'شقة حديثة بغرفة معيشة مفتوحة مع إطلالة على البحر'
},
{
  id: 'own-002',
  title: 'فيلا مستقلة 5 غرف مع مسبح خاص — جزيرة السعديات',
  type: 'فيلا',
  mode: 'sale',
  price: 5800000,
  priceUnit: 'AED',
  city: 'أبوظبي',
  district: 'جزيرة السعديات',
  area: 520,
  bedrooms: 5,
  status: 'published',
  views: 874,
  unlocks: 42,
  listedAt: '2026-03-28',
  expiresAt: '2026-06-28',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_17f167eca-1772191565057.png",
  imageAlt: 'فيلا فاخرة بواجهة حجرية ومسبح خارجي'
},
{
  id: 'own-003',
  title: 'أرض سكنية في مدينة محمد بن زايد — 600 م²',
  type: 'أرض',
  mode: 'sale',
  price: 1200000,
  priceUnit: 'AED',
  city: 'أبوظبي',
  district: 'مدينة محمد بن زايد',
  area: 600,
  bedrooms: null,
  status: 'published',
  views: 143,
  unlocks: 5,
  listedAt: '2026-04-03',
  expiresAt: '2026-07-03',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1097c4409-1774514615488.png",
  imageAlt: 'قطعة أرض في منطقة سكنية هادئة في أبوظبي'
},
{
  id: 'own-004',
  title: 'شقة غرفتين قريبة من جامعة الشارقة',
  type: 'شقة',
  mode: 'rent',
  price: 4800,
  priceUnit: 'AED/شهر',
  city: 'الشارقة',
  district: 'حي الجامعة',
  area: 95,
  bedrooms: 2,
  status: 'paused',
  views: 267,
  unlocks: 22,
  listedAt: '2026-03-15',
  expiresAt: '2026-06-15',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_105090c3a-1772234095413.png",
  imageAlt: 'شقة صغيرة بغرفة نوم قريبة من الجامعة'
},
{
  id: 'own-005',
  title: 'فيلا دوبلكس في نخلة جميرا — تشطيب سوبر لوكس',
  type: 'فيلا',
  mode: 'sale',
  price: 12500000,
  priceUnit: 'AED',
  city: 'دبي',
  district: 'نخلة جميرا',
  area: 680,
  bedrooms: 6,
  status: 'draft',
  views: 0,
  unlocks: 0,
  listedAt: '2026-04-04',
  expiresAt: '2026-07-04',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_13dc422ac-1772210226514.png",
  imageAlt: 'فيلا دوبلكس فخمة بواجهة بيضاء على نخلة جميرا'
},
{
  id: 'own-006',
  title: 'مكتب تجاري في برج خليفة — الدور 30',
  type: 'مكتب',
  mode: 'rent',
  price: 28000,
  priceUnit: 'AED/شهر',
  city: 'دبي',
  district: 'وسط مدينة دبي',
  area: 220,
  bedrooms: null,
  status: 'expired',
  views: 198,
  unlocks: 9,
  listedAt: '2026-01-01',
  expiresAt: '2026-04-01',
  image: "https://images.unsplash.com/photo-1646699474910-3467e2f1f032",
  imageAlt: 'مكتب عصري بنوافذ زجاجية في برج خليفة'
},
{
  id: 'own-007',
  title: 'شاليه على شاطئ الجميرا — تأجير أسبوعي وشهري',
  type: 'شاليه',
  mode: 'rent',
  price: 18500,
  priceUnit: 'AED/شهر',
  city: 'دبي',
  district: 'شاطئ الجميرا',
  area: 310,
  bedrooms: 4,
  status: 'featured',
  views: 651,
  unlocks: 37,
  listedAt: '2026-03-25',
  expiresAt: '2026-06-25',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_10f7e8db1-1772691748547.png",
  imageAlt: 'شاليه فاخر مطل على شاطئ الجميرا في دبي'
},
{
  id: 'own-008',
  title: 'مستودع تجاري 800 م² في جبل علي',
  type: 'مستودع',
  mode: 'rent',
  price: 35000,
  priceUnit: 'AED/شهر',
  city: 'دبي',
  district: 'جبل علي',
  area: 800,
  bedrooms: null,
  status: 'published',
  views: 89,
  unlocks: 4,
  listedAt: '2026-04-03',
  expiresAt: '2026-07-03',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1108d5c5a-1775324442941.png",
  imageAlt: 'مستودع واسع بأبواب معدنية في منطقة جبل علي'
}];


export const STATUS_CONFIG: Record<OwnerListingStatus, {label: string;color: string;bg: string;}> = {
  published: { label: 'منشور', color: 'text-emerald-700', bg: 'bg-emerald-50 border-emerald-200' },
  featured: { label: 'مميز', color: 'text-amber-700', bg: 'bg-amber-50 border-amber-200' },
  draft: { label: 'مسودة', color: 'text-gray-600', bg: 'bg-gray-100 border-gray-200' },
  expired: { label: 'منتهي', color: 'text-red-600', bg: 'bg-red-50 border-red-200' },
  paused: { label: 'موقوف', color: 'text-orange-600', bg: 'bg-orange-50 border-orange-200' }
};

export const MONTHLY_STATS = [
{ month: 'أكتوبر', views: 420, unlocks: 28 },
{ month: 'نوفمبر', views: 380, unlocks: 22 },
{ month: 'ديسمبر', views: 510, unlocks: 34 },
{ month: 'يناير', views: 670, unlocks: 41 },
{ month: 'فبراير', views: 590, unlocks: 38 },
{ month: 'مارس', views: 820, unlocks: 55 },
{ month: 'أبريل', views: 312, unlocks: 18 }];